
export default {
  routeDetails: {
    routeDetails: 'Routendetails',
    warnings: 'Warnungen',
    routes: 'Routen',
    route: 'Route',
    segments: 'Abschnitte',
    segment: 'Abschnitt',
    instructions: 'Wegbeschreibung',
    instruction: 'Wegbeschreibung',
    name: 'Name',
    selectRoute: 'Wähle diese Route',
    selectedRoute: 'Gewählte Route',
    gotoSegment: 'Gehe zu Abschnitt',
    warningCodes: {
      1: 'Bei manchen Straßen können Zufahrts- oder Zugangsbeschränkungen gelten',
      2: 'Diese Route nutzt Mautstraßen',
      3: 'Die Route nutzt direkte Wegpunkte. Dauer und Zugangsbeschränkungen können falsch sein.',
      4: 'Mindestens eine angefragte extra Info ist nicht verfügbar.'
    },
    routeOpacity: 'Routendeckkraft'
  }
}
